<template>
  <header class="page-head tech-parallax-header">
    <div class="parallax-container">
      <div class="parallax-bg"></div>
      <div class="overlay"></div>
      <div class="circuit-layer"></div>
      <div class="data-flow">
        <div class="data-line"></div>
        <div class="data-line"></div>
        <div class="data-line"></div>
      </div>
      <div class="tech-dots">
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
      </div>
      <div class="circuit-paths">
        <div class="path path-1"></div>
        <div class="path path-2"></div>
        <div class="path path-3"></div>
      </div>
    </div>

    <!-- Overlay content -->
    <div class="header-wrapper">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <!-- <ol class="breadcrumb">
              <li><a href="index.html">Início</a></li>
              <li class="active">Sobre Nós</li>
            </ol> -->
            <!-- end of /.breadcrumb -->
          </div>
        </div>
      </div>
      <!-- /.container -->
    </div>
    <!-- /.header-wrapper -->
  </header>
</template>

<script>
export default {
  name: "HeaderAboutSection",
};
</script>

<style scoped>
/* Tech Parallax Header Styles */
.tech-parallax-header {
  position: relative;
  overflow: hidden;
  height: 157px;
}

.parallax-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: 1;
}

.parallax-bg {
  position: absolute;
  width: 100%;
  height: 120%;
  background-image: url("~@/assets/img/tech-parallax-bg.png");
  background-position: center -3000px;
  background-size: 1894px auto;
  background-attachment: fixed;
  z-index: 1;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    rgba(0, 18, 36, 0.6) 0%,
    rgba(9, 9, 121, 0.2) 50%,
    rgba(0, 18, 36, 0.6) 100%
  );
  z-index: 2;
}

.circuit-layer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 3;
  opacity: 0.15;
  background: radial-gradient(
      circle at 20% 30%,
      rgba(64, 219, 255, 0.2) 0%,
      transparent 50px
    ),
    radial-gradient(
      circle at 80% 70%,
      rgba(64, 219, 255, 0.2) 0%,
      transparent 50px
    ),
    radial-gradient(
      circle at 50% 50%,
      rgba(64, 219, 255, 0.1) 0%,
      transparent 80px
    );
}

.data-flow {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 4;
}

.data-line {
  position: absolute;
  height: 1px;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(64, 219, 255, 0.7),
    transparent
  );
  animation: flowAnimation 3s infinite linear;
}

.data-line:nth-child(1) {
  top: 30%;
  width: 60%;
  left: 5%;
}

.data-line:nth-child(2) {
  top: 50%;
  width: 40%;
  left: 30%;
  animation-delay: 0.5s;
}

.data-line:nth-child(3) {
  top: 70%;
  width: 70%;
  left: 15%;
  animation-delay: 1s;
}

.tech-dots {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 5;
}

.dot {
  position: absolute;
  width: 3px;
  height: 3px;
  border-radius: 50%;
  background-color: rgba(64, 219, 255, 0.8);
  animation: pulse 2s infinite;
}

.dot:nth-child(1) {
  top: 20%;
  left: 10%;
  animation-delay: 0s;
}
.dot:nth-child(2) {
  top: 30%;
  left: 25%;
  animation-delay: 0.3s;
}
.dot:nth-child(3) {
  top: 15%;
  left: 40%;
  animation-delay: 0.6s;
}
.dot:nth-child(4) {
  top: 40%;
  left: 55%;
  animation-delay: 0.9s;
}
.dot:nth-child(5) {
  top: 25%;
  left: 70%;
  animation-delay: 1.2s;
}
.dot:nth-child(6) {
  top: 35%;
  left: 85%;
  animation-delay: 1.5s;
}
.dot:nth-child(7) {
  top: 60%;
  left: 15%;
  animation-delay: 1.8s;
}
.dot:nth-child(8) {
  top: 70%;
  left: 30%;
  animation-delay: 2.1s;
}
.dot:nth-child(9) {
  top: 55%;
  left: 45%;
  animation-delay: 2.4s;
}
.dot:nth-child(10) {
  top: 65%;
  left: 60%;
  animation-delay: 2.7s;
}
.dot:nth-child(11) {
  top: 75%;
  left: 75%;
  animation-delay: 3s;
}
.dot:nth-child(12) {
  top: 50%;
  left: 90%;
  animation-delay: 3.3s;
}

.circuit-paths {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 6;
  opacity: 0.2;
}

.path {
  position: absolute;
  border: 1px solid rgba(64, 219, 255, 0.5);
  border-radius: 20px;
}

.path-1 {
  top: 20%;
  left: 100px;
  width: 200px;
  height: 40px;
  border-right: none;
  border-bottom: none;
}

.path-2 {
  top: 60%;
  left: 40%;
  width: 300px;
  height: 60px;
  border-left: none;
  border-top: none;
}

.path-3 {
  top: 30%;
  right: 200px;
  width: 250px;
  height: 50px;
  border-left: none;
  border-bottom: none;
}

/* Header wrapper overlay */
.header-wrapper {
  position: relative;
  z-index: 10;
  background-color: rgba(0, 0, 0, 0.45);
  padding: 65px 0px;
}

/* Animations */
@keyframes flowAnimation {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}

@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.5);
    opacity: 0.7;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .path-1,
  .path-2,
  .path-3 {
    width: 150px;
    height: 30px;
  }

  .data-line {
    width: 50% !important;
  }

  .dot {
    width: 2px;
    height: 2px;
  }

  /* Hide some elements on mobile */
  .dot:nth-child(n + 7),
  .path-3 {
    display: none;
  }
}

@media (max-width: 480px) {
  .circuit-layer {
    opacity: 0.1;
  }

  .data-flow {
    opacity: 0.8;
  }

  .dot:nth-child(n + 5) {
    display: none;
  }
}
</style>
